import { useState } from 'react';

const useInput = (validateValue) => {
    const [enteredValue, setEnteredValue] = useState('');
    const [repeatedValue, setRepeatedValue] = useState('');

    const valueIsValid = validateValue(enteredValue, repeatedValue);
    const hasError = !valueIsValid;

    const valueChangeHandler = (value) => {
        setEnteredValue(value);
    };

    const secondValueChangeHandler = (value) => {
        setRepeatedValue(value);
    };

    const reset = () => {
        setEnteredValue('');
        setRepeatedValue('');
    };

    return {
        value: enteredValue,
        secondValue: repeatedValue,
        isValid: valueIsValid,
        hasError,
        valueChangeHandler,
        secondValueChangeHandler,
        reset
    };
};

export default useInput;
